import { Turnstile } from "@marsidev/react-turnstile"
import PropTypes from "prop-types"
import React, { useRef } from "react"

/**
 * TurnstileField Component
 *
 * This component wraps Cloudflare's Turnstile in a div that can receive focus.
 * The wrapper div is necessary because:
 * 1. react-hook-form attempts to focus fields when there are validation errors
 * 2. The Turnstile component itself is not a focusable element
 * 3. Without a focusable wrapper, react-hook-form would throw errors when trying to focus the field
 *
 * By wrapping Turnstile in a div with tabIndex, we provide a focusable element
 * that satisfies react-hook-form's focus management without affecting the
 * Turnstile's functionality.
 */
const TurnstileField = ({ onChange }) => {
  const wrapperRef = useRef(null)
  const siteKey = window?.turnstileSettings?.siteKey

  if (!siteKey) {
    throw new Error("Turnstile site key is not defined.")
  }

  return (
    <div ref={wrapperRef} tabIndex={-1}>
      <Turnstile
        siteKey={siteKey}
        onSuccess={onChange}
        onError={() => onChange("error")}
        onExpire={() => onChange("expired")}
        options={{ theme: "light" }}
      />
    </div>
  )
}

TurnstileField.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default TurnstileField
